import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class MessageClaraDraftSourceItemField extends BaseModel {
  label?: string | null;
  value: string;

  constructor(model: Partial<MessageClaraDraftSourceItemField> = {}) {
    super(model);

    this.label = model.label;
    this.value = model.value ?? '';
  }
}
